<template>
  <div :class="config.template_wrapper_class" v-if="props.config.steps">
    <div class="wpcm-row m-0">
      <slot name="left_sidebar"></slot>
      <div class="wpcm-col col-content" :style="{ backgroundImage: `url(${config.background_image})` }">
        <slot name="global_top"></slot>
        <div v-for="(step) in props.config.steps" :key="step + randKey">
          <div v-if="step == props.currentStep" :key="step + randKey">
            <div class="wpcm-row">
              <slot :name="`step_${step}_ttop`"></slot>
              <slot :name="`step_${step}_top`"></slot>
              <slot :name="`step_${step}_middle`"></slot>
              <slot :name="`step_${step}_bottom`"></slot>
            </div>
          </div>
        </div>
        <slot name="global_bottom"></slot>
      </div>
      <slot name="right_sidebar"></slot>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
const props = defineProps(['config', 'currentStep']);

const randKey = computed(() => {
  return (Math.random() + 1).toString(36).substring(7);
})

</script>